var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"reference-link",attrs:{"to":("/search/" + (encodeURIComponent(_vm.word)))}},[_vm._v(_vm._s(_vm.word))])}
var staticRenderFns = []

export { render, staticRenderFns }